<template>
  <div class="form-contact">
    <div class="content row">
      <div class="col-lg-10">
        <h3 v-if="typeof formSchema.title != 'undefined'">
          {{ formSchema.title }}
        </h3>
        <p class="main-p">
          {{ formSchema.description }}
        </p>
        <form @submit.prevent="sendData(formData)">
          <div class="contact-page-form">
            <div class="contact-input">
              <div class="contact-inner">
                <span>Ubicación</span>
                <select v-model="formData.ubicacion" required>
                  <option value="" disabled>Selecciona tu ubicación</option>
                  <option value="Barcelona">Barcelona</option>
                  <option value="La Coruña">A Coruña</option>
                  <option value="Terrassa">Terrassa</option>
                  <option value="Ninguna">Ninguna</option>
                </select>
              </div>

              <div class="contact-inner">
                <span>Motivo de contacto</span>
                <select v-model="formData.motivo" required>
                  <option value="" disabled>Selecciona una opción</option>
                  <option value="Reserva de grupo">Reserva de grupo</option>
                  <option value="Propuesta de franquicia">Propuesta de franquicia</option>
                  <option value="Contacto de prensa">Contacto de prensa</option>
                  <option value="Feedback">Feedback</option>
                  <option value="Otros">Otras consultas</option>
                </select>
              </div>

              <div
                class="contact-inner"
                v-for="item in formSchema.form.filter(
                  (item) => item.type == 'input'
                )"
                :key="item.name"
              >
                <span>{{ item.title }}</span>
                <input
                  :name="'con_' + item.name"
                  type="text"
                  :placeholder="item.placeholder"
                  v-model="formData[item.name]"
                  required
                />
              </div>
            </div>

            <div class="contact-inner">
              <span>Teléfono de contacto (opcional)</span>
              <input
                type="tel"
                name="con_telefono"
                placeholder="ej: +34 600 123 456"
                v-model="formData.telefono"
              />
            </div>

            <div
              class="contact-inner contact-message"
              v-for="item in formSchema.form.filter(
                (item) => item.type == 'textarea'
              )"
              :key="item.name"
            >
              <span>{{ item.title }}</span>
              <textarea
                :name="'con_' + item.name"
                :placeholder="item.placeholder"
                v-model="formData[item.name]"
                required
              ></textarea>
            </div>

            <div class="contact-submit-btn d-flex justify-content-end">
              <div class="main-button">
                <button type="submit">
                  {{
                    formSchema.form.find((item) => item.type == "button").title
                  }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

</template>

<script>
import { onMounted, ref } from "vue";
import LayoutLanding from "@/components/LayoutLanding.vue";
import { VueReCaptcha, useReCaptcha } from "vue-recaptcha-v3";

export default {
  name: "FranchiseView",
  components: {
    LayoutLanding,
  },
  props: {
    formSchema: { type: Object, default: [{}] },
    buttonFunction: { type: Function, default: () => {} },
  },
  setup(props) {
    const { executeRecaptcha, recaptchaLoaded } = useReCaptcha();

    const formData = ref({
      ubicacion: "",
      motivo: "",
      telefono: ""
    });

    onMounted(() => {
      props.formSchema.form.forEach((item) => {
        if (item.type !== "button") {
          formData.value[item.name] = "";
        }
      });
    });

    const sendData = async (data) => {
      await recaptchaLoaded();
      const token = await executeRecaptcha("login");
      data.token = token;
      props.buttonFunction(data);

      formData.value = {
        ubicacion: "",
        motivo: "",
        telefono: ""
      };

      props.formSchema.form.forEach((item) => {
        if (item.type !== "button") {
          formData.value[item.name] = "";
        }
      });
    };

    return { formData, sendData };
  },
};
</script>
